import React from 'react'
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
  } from '@chakra-ui/react'
const AlertBox = () => {
  return (
    <Alert status='success'>
    <AlertIcon />
   Product Added Successfully
  </Alert>

  )
}

export default AlertBox